import MaskedInput from 'vue-text-mask';
import { mapState } from 'vuex';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

import Hint from '@/components/Hint/Hint.vue';
library.add(faSync);

export default {
  name: 'markups',

  props: {
    constructorId: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id,
      commonMarkups: state => state.markups.commonMarkups
    }),
    markups() {
      return this.commonMarkups[this.constructorId];
    }
  },

  methods: {
    updateMarkup(key, markup) {
      if (!markup && markup !== 0) {
        this.flashError('Укажите наценку');
        return;
      } else if (markup > 100) {
        this.flashError('Наценка должна быть меньше 100%');
        return;
      } else if (markup < 0) {
        this.flashError('Наценка должна быть больше 0%');
        return;
      }

      const updatePromise = this.$store.dispatch('updateCommonMarkup', {
        firmId: this.firmId,
        constructorId: this.constructorId,
        name: key,
        markup
      });

      updatePromise.then(
        () => {
          this.flashSuccess('Данные о наценке обновлены');
        },
        error => {
          this.flashError('Не удалось сохранить наценку');
          console.error(error);
        }
      );

      return updatePromise;
    },

    percentToFloat(percentValue) {
      return percentValue / 100;
    }
  },

  filters: {
    floatToPercent(floatValue) {
      return (floatValue * 100).toString();
    }
  },

  components: {
    MaskedInput,
    FontAwesomeIcon,
    Hint
  }
};
